export const DFP = 'DFP';
export const FREEWHEEL = 'FREEWHEEL';
export const VIDEO_MIDROLL = 'midroll';
export const VIDEO_POSTROLL = 'postroll';
export const VIDEO_PREROLL = 'preroll';



// WEBPACK FOOTER //
// ./src/common/constants/ad-type.js